import * as Yup from "yup";

export const bannerSchema = Yup.object().shape({
  type: Yup.string().required("Banner type is required"),
  location: Yup.string().when("type", {
    is: (type) => type === "general",
    then: (schema) => schema.required("Page is required for general banner"),
    otherwise: (schema) => schema.required("Banner location is required"),
  }),
  image: Yup.string().when("type", {
    is: (type) => type === "general",
    then: (schema) =>
      schema.required("Banner image is required for general banner"),
    otherwise: (schema) => schema.required("Banner image/video is required"),
  }),
  status: Yup.string()
    .oneOf(["active", "inactive"])
    .when("type", {
      is: (type) => type === "general",
      then: (schema) =>
        schema.required("Status is required for general banner"),
      otherwise: (schema) => schema.required("Status is required"),
    }),
  title: Yup.string().nullable(),
  media_type: Yup.string().oneOf(["image", "video"]).nullable(),
  is_global: Yup.boolean().nullable(),
  is_approved: Yup.boolean().nullable(),
  validity: Yup.number().min(0).nullable(),
  seq_no: Yup.number().min(0).nullable(),
  link_type: Yup.string().nullable(),
  link_url: Yup.string().nullable(),
  gym_id: Yup.string().nullable(),
  staff_id: Yup.string().nullable(),
  is_staff: Yup.boolean().nullable(),
  isRemove: Yup.boolean().nullable(),
  category_id: Yup.number().nullable(),
  display_name: Yup.string().nullable(),
});

export const tvBannerSchema = Yup.object().shape({
  type: Yup.string().oneOf(["tv"]).required("Banner type is required"),
  image: Yup.string().required("Banner image is required for TV banner"),
  is_global: Yup.number().oneOf([0, 1]).required("Visibility is required"),
  status: Yup.string()
    .oneOf(["active", "inactive"])
    .required("Status is required"),
  // All other fields optional or nullable
  location: Yup.string().nullable(),
  gym_id: Yup.string().nullable(),
  validity: Yup.number().nullable(),
  is_tv: Yup.number().nullable(),
  schedule_type: Yup.string().nullable(),
  is_website: Yup.number().nullable(),
  website_schedule: Yup.number().nullable(),
  isRemove: Yup.number().nullable(),
  cta: Yup.number().nullable(),
  is_approved: Yup.number().nullable(),
});

export const websiteBannerSchema = Yup.object().shape({
  type: Yup.string().required("Banner type is required"),
  location: Yup.string().required("Page is required"),
  image: Yup.string().required("Desktop banner image is required"),
  mobile_banner: Yup.string()
    .url("Mobile banner must be a valid URL")
    .required("Mobile banner is required"),
  status: Yup.string()
    .oneOf(["active", "inactive"])
    .required("Status is required"),
  schedule_type: Yup.string().nullable(),
  schedule_at: Yup.string().nullable(),
  is_website: Yup.number().oneOf([0, 1]).required("is_website is required"),
  website_schedule: Yup.number()
    .oneOf([0, 1])
    .required("website_schedule is required"),
  color_code: Yup.string().nullable(),
  cta: Yup.number().oneOf([0, 1]),
  cta_type: Yup.string().nullable(),
  cta_url: Yup.string().nullable(),
  title: Yup.string().nullable(),
  message: Yup.string().nullable(),
  recipe_id: Yup.string().nullable(),
  obj: Yup.mixed().nullable(),
  isRemove: Yup.number().nullable(),
  validity: Yup.number().nullable(),
  is_tv: Yup.number().nullable(),
  gym_id: Yup.string().nullable(),
  is_global: Yup.number().nullable(),
});
